import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./question.css";
import { Link, NavLink } from "react-router-dom";
import tours from "../../../datebase/tours";

const Question = ({ t, langcat, setScoreTours, scoreTours }) => {
    const [textActive, setTextActive] = useState(false);
    function TypingText({ text, speed = 30, active }) {
        const [output, setOutput] = useState("");
        const [index, setIndex] = useState(0);

        useEffect(() => {
            if (!active) {
                setOutput("");
                setIndex(0);
                return;
            }

            if (index < text.length) {
                const timer = setTimeout(() => {
                    setOutput(prev => prev + text[index]);
                    setIndex(prev => prev + 1);
                }, speed);

                return () => clearTimeout(timer);
            }
        }, [index, text, speed, active]);

        return <span className="typing-text">{output}</span>;
    }
    function showStatus(e) {
        const requeststatusscreen = document.querySelector(".request-status-screen")
        const spinnerblock = document.querySelector(".spinner-block")
        const checkblock = document.querySelector(".check-block")
        if (e == true) {
            requeststatusscreen.classList.add("active");
            spinnerblock.classList.add("activeSpiner");
            checkblock.classList.remove("active");
            spinnerblock.classList.remove("activeCheck");
            setTextActive(false)

            setTimeout(() => {
                spinnerblock.classList.remove("activeSpiner");
                checkblock.classList.add("active");
                spinnerblock.classList.add("activeCheck");
                setTextActive(true)

            }, 3000);
        }
        else {
            requeststatusscreen.classList.remove("active");
            spinnerblock.classList.remove("activeSpiner");
            checkblock.classList.remove("active");
            spinnerblock.classList.remove("activeCheck");
            setTextActive(false)
        }
    }
    const formRequred = (e) => {
        const name = document.querySelector("#nameQuestion");
        const nameActive = document.querySelectorAll(".nameActiveQuestion");
        const email = document.querySelector("#emailQuestion");
        const emailActive = document.querySelectorAll(".emailActiveQuestion");
        const message = document.querySelector("#messageQuestion");
        const messageActive = document.querySelectorAll(".messageActiveQuestion");
        let hasError = false;
        if (name.value.trim() === "") {
            nameActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            nameActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (email.value.trim() === "") {
            emailActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            emailActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (message.value.trim() === "") {
            messageActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            messageActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (hasError) {
        } else {
            form1func();
            showStatus(true)
        }
    }
    const form1func = (e) => {
        const TOKEN = "6987592551:AAFnBgdjEOXi7m9Ja857NMX-4iWe5YQq41k";
        const CHAT_ID = "-1003658109531";
        const URI_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`;
        const name = document.querySelector("#nameQuestion");
        const phoneNumber = document.querySelector("#phoneNumberQuestion");
        const email = document.querySelector("#emailQuestion");
        const message = document.querySelector("#messageQuestion");
        let mes = `<b>🆘 🆘 Задан вопрос 🆘 🆘</b>\n\n`;
        mes += `<b>🆔ФИО: </b>${name.value}\n`;
        mes += `<b>📲Номер Телефон: </b>${phoneNumber.value} \n`;
        mes += `<b>💌Почта: </b>${email.value} \n\n`;
        mes += `<b>💬Сообщение: </b>${message.value} \n`;
        axios.post(URI_API, {
            chat_id: CHAT_ID,
            parse_mode: "HTML",
            text: mes
        })
            .then((res) => {
            })
            .catch((error) => {
            })
            .finally(() => {
                name.value = "";
                phoneNumber.value = "";
                email.value = "";
                message.value = ""
            })
    }
    return (
        <>
            <div className="question">
                <div className="request-status-screen">
                    <div className="request-status-screen-flex">
                        <div className="spinner-block">
                            <span>
                                <i class="fa fa-spinner" aria-hidden="true"></i>
                            </span>
                            <span>
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div className="check-block">
                            <span id="typingText">
                                <TypingText active={textActive} text={t("requeststatusscreen")} speed={20} />
                            </span>
                            <span>
                                <button onClick={() => { showStatus(false) }}>
                                    Закрыть
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="question-flex">
                        <div className="question-block1">
                            <div className="question-block1-input">
                                <label className="labQuestion nameActiveQuestion" for="nameQuestion">{t("request.fio")}</label>
                                <input className="inpQuestion nameActiveQuestion" id="nameQuestion" type="text" />
                            </div>
                            <div className="question-block1-input">
                                <label for="phoneNumberQuestion">{t("request.phonenumber")}</label>
                                <input id="phoneNumberQuestion" type="number" />
                            </div>
                            <div className="question-block1-input">
                                <label className="labQuestion emailActiveQuestion" for="emailQuestion">{t("request.email")}</label>
                                <input className="inpQuestion emailActiveQuestion" id="emailQuestion" type="email" />
                            </div>
                            <div className="question-block1-input">
                                <label className="labQuestion messageActiveQuestion" for="messageQuestion">{t("request.soobchenie")}</label>
                                <textarea className="inpQuestion messageActiveQuestion message" name="messageQuestion" placeholder={`(${t("request.soobcheniedp")})`} id="messageQuestion" />
                            </div>
                            <div className="question-block1-input">
                                <div className="request-box2-sec2-block1-btn6">
                                    <div>
                                        <button onClick={formRequred}>{t("btn-send")}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="question-block2">
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Question;
